export default __webpack_public_path__ + "static/media/doctors-2.07d1b7c1.jpg";